import { useCreditFacilityLoanVersionsTableDataRetrieveSuspense } from "gen/endpoints/credit-facility/credit-facility";
import { useTranslation } from "react-i18next";
import { TableBox } from "shared/components/table/box/TableBox";
import { TableBoxBody } from "shared/components/table/box/TableBoxBody";
import { TableBoxCollapse } from "shared/components/table/box/TableBoxCollapse";
import { TableBoxHeader } from "shared/components/table/box/TableBoxHeader";
import { TableBoxTitle } from "shared/components/table/box/TableBoxTitle";
import { DataTable } from "shared/components/table/data/DataTable";
import { DataTableBoxActions } from "shared/components/table/data/DataTableBoxActions";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";

export const CreditFacilitySettingsLoanVersionTable = () => {
  const { t } = useTranslation(["creditFacility", "common"]);

  const { fundFamilyId, creditFacilityId, loanId } = useRequiredStringParams();

  const { data: versionTableData } =
    useCreditFacilityLoanVersionsTableDataRetrieveSuspense(
      fundFamilyId,
      creditFacilityId,
      loanId,
    );

  return (
    <TableBox>
      <TableBoxHeader>
        <TableBoxTitle textStyle="bodyBold">
          {t("creditFacility:settings.versionHistory")}
        </TableBoxTitle>
        <DataTableBoxActions />
      </TableBoxHeader>
      <TableBoxBody>
        <TableBoxCollapse>
          <DataTable data={versionTableData} />
        </TableBoxCollapse>
      </TableBoxBody>
    </TableBox>
  );
};
